<dx-list class="list"
  [dataSource]="permissions"
  selectionMode="single"
  pageLoadMode="scrollBottom">
  <div *dxTemplate="let data of 'item'">

    <!-- [altri elementi che erano presenti in Class = "" ] ==>  content-block -->
    <div class=" dx-card wide-card responsive-paddings"
         [ngClass]="{
           'causal-pending': data.causal === '',
           'causal-approved': data.causal === 'Accettato',
           'causal-rejected': data.causal === 'Rifiutato'
         }"
      (click)="onCardClick(data)">
      @if (data.startTimeString && data.endTimeString) {
        <span>
          <div>
            Tipo richiesta: <strong>permesso</strong>
          </div>
          <div>
            Giorno: <strong>{{data.day | date:'yyyy-MM-dd'}}</strong>
          </div>
          <div>
            Ora Inizio: <strong>{{data.startTimeString}}</strong>
          </div>
          <div>
            Ora fine: <strong>{{data.endTimeString }}</strong>
          </div>
        </span>
      }
      @if (!data.startTimeString || !data.endTimeString) {
        <span>
          <div>
            Tipo richiesta: <strong>ferie</strong>
          </div>
          <div>
            Giorno inizio: <strong>{{data.startDay | date:'yyyy-MM-dd'}}</strong>
          </div>
          <div>
            Giorno fine: <strong>{{data.endDay | date:'yyyy-MM-dd'}}</strong>
          </div>
        </span>
      }
      <div>
        Causale: <strong>{{data.causal}}</strong>
      </div>
      <div>
        Dipendente Richiedente: <strong>{{data.workerNumber }}</strong>
      </div>
    </div>
  </div>
</dx-list>
